import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportAppealsToExcel = async (data, fields, filename) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Лист1');

  const headerRow = sheet.addRow(fields.map((f) => f.title));
  headerRow.font = { bold: true };

  data.forEach((row) => {
    const values = fields.map((f) =>
      typeof f.dataIndex === 'function' ? f.dataIndex(row) : row[f.dataIndex]
    );
    const excelRow = sheet.addRow(values);

    if (row.color === '#ff4a4a') {
      excelRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFC7CE' },
        };
        cell.font = { color: { argb: 'FF9C0006' } };
      });
    }
  });

  sheet.columns.forEach((column, i) => {
    let maxLength = (fields[i].title || '').length;

    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value !== null && cell.value !== undefined ? String(cell.value) : '';
      if (cellValue.length > maxLength) {
        maxLength = cellValue.length;
      }
    });

    column.width = Math.min(Math.max(maxLength + 2, 12), 60);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${filename}.xlsx`);
};
